import { colors } from '../../variables.style'
import { createUseStyles } from 'react-jss'

export const style = {
  backLink: {
    '&:hover': {
      color: colors.oriolesOrange
    }
  },
  backIcon: {
    composes: 'font-icon-chevron-left',
    fontSize: '20px',
    margin: '8px 6px 0 0'
  },
  backText: {
    margin: 'auto 0'
  },
  hoverAnchor: {
    cursor: 'pointer'
  }
}

export const useStyles = createUseStyles(style)
